import axios from "axios";
import {URL_API} from "@/config/utils";

export class StatusService{
   BASE_URL:string;
   constructor(){
    this.BASE_URL = `${URL_API}status`;
   }

   async getAll(token:string):Promise<string[]>{

     const config = {headers:{"Authorization": `Bearer ${token}`}}
     const resp = await axios.get(`${this.BASE_URL}`,config);
     return await resp.data;
   }
}//fin de clase
